import { render, staticRenderFns } from "./TransferGraduationInstitutionInfo.vue?vue&type=template&id=20dc9241&scoped=true&"
import script from "./TransferGraduationInstitutionInfo.vue?vue&type=script&lang=ts&"
export * from "./TransferGraduationInstitutionInfo.vue?vue&type=script&lang=ts&"
import style0 from "./TransferGraduationInstitutionInfo.vue?vue&type=style&index=0&id=20dc9241&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dc9241",
  null
  
)

export default component.exports